import React, { FC } from 'react'

import { IconCloudDownloadProps } from './IconCloudDownload.types'
import * as Styled from './styles/IconCloudDownload.style'

import { nonThemeableRules } from '../../ruleSet'

const IconCloudDownload: FC<IconCloudDownloadProps> = ({
  size = nonThemeableRules.defaultSize as number as IconCloudDownloadProps['size'],
  isResponsive = false,
}: IconCloudDownloadProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M29.588 31s5.61.215 7.797-.75a9.566 9.566 0 0 0 5.57-7.75c.328-3.273-1.165-6.867-3.985-8.607-1.402-.863-3.04-1.213-4.677-1.356a19.57 19.57 0 0 0-2.798.125 10.915 10.915 0 0 0-9.48-7.62 10.652 10.652 0 0 0-8.93 3.776 11 11 0 0 0-2.227 4.364c-.108.425-.32 1.61-.32 1.61a8.366 8.366 0 0 0-2.968 1.683C4.943 18.825 4.303 22.84 5.773 26c1.335 2.87 4.202 5 7.392 5h5.25'
          stroke='#fff'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path d='M24 22v21m6.5-7L24 43l-6.5-7' stroke='#EA1A1A' strokeLinecap='round' strokeLinejoin='round' strokeWidth='2' />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconCloudDownload
